import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-layout-document-list',
  templateUrl: './layout-document-list.component.html',
  styleUrls: ['./layout-document-list.component.scss']
})
export class LayoutDocumentListComponent implements OnInit {
  @Input() inputData: any;
  documentList = dummyData;
  
  // Modal State
  isModalOpen = false;
  selectedDocumentUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  openDocument(url: string, event: Event) {
    event.preventDefault(); // Prevent default anchor tag behavior
    // Sanitize the URL so Angular allows it in an iframe
    this.selectedDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectedDocumentUrl = null;
  }
}

const dummyData = [
  {
    imageUrl: "https://via.placeholder.com/150?text=Image+1",
    Title: "Sample Title 1",
    Details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
  },
  {
    imageUrl: "https://via.placeholder.com/150?text=Image+2",
    Title: "Sample Title 2",
    Details: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  },
  {
    imageUrl: "https://via.placeholder.com/150?text=Image+3",
    Title: "Sample Title 3",
    Details: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
  }
];

